import Vue from "vue";
import App from "./App.vue";
import vSelect from "vue-select";

Vue.config.productionTip = false;
Vue.component("v-select", vSelect.VueSelect);

/* eslint-disable no-new */
new Vue({
  el: "#monthly-price-posting-app",
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js